/**
 * @generated SignedSource<<1a3157ad18705262cb98e3199d606eec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AnalysisForecastBwaViewQuery$variables = Record<PropertyKey, never>;
export type AnalysisForecastBwaViewQuery$data = {
  readonly bankAccounts: ReadonlyArray<{
    readonly bankAccountIdentifier: string;
    readonly id: string;
    readonly name: string;
  }>;
  readonly bwaMonths: ReadonlyArray<{
    readonly balances: ReadonlyArray<{
      readonly bankAccountIdentifier: string;
      readonly bankAccountName: string;
      readonly closingBalance: number;
      readonly computedBalance: number;
      readonly difference: number;
    }>;
    readonly changedAt: any | null | undefined;
    readonly changedBy: string | null | undefined;
    readonly figures: {
      readonly depreciation: number;
      readonly hostingAndLicences: number;
      readonly incomeTaxes: number;
      readonly otherCosts: number;
      readonly otherOperatingIncome: number;
      readonly personnelCosts: number;
      readonly revenue: number;
    };
    readonly id: string;
    readonly month: string;
    readonly recordedAt: any;
    readonly recordedBy: string;
  }>;
};
export type AnalysisForecastBwaViewQuery = {
  response: AnalysisForecastBwaViewQuery$data;
  variables: AnalysisForecastBwaViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bankAccountIdentifier",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BwaMonth",
    "kind": "LinkedField",
    "name": "bwaMonths",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "month",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BwaFigures",
        "kind": "LinkedField",
        "name": "figures",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revenue",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherOperatingIncome",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personnelCosts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hostingAndLicences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "otherCosts",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "depreciation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "incomeTaxes",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recordedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BwaMonthBalance",
        "kind": "LinkedField",
        "name": "balances",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bankAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "closingBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "computedBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difference",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BankAccount",
    "kind": "LinkedField",
    "name": "bankAccounts",
    "plural": true,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastBwaViewQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AnalysisForecastBwaViewQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9ef8b462e6dbaa0095facb761c8c6a05",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastBwaViewQuery",
    "operationKind": "query",
    "text": "query AnalysisForecastBwaViewQuery {\n  bwaMonths {\n    id\n    month\n    figures {\n      revenue\n      otherOperatingIncome\n      personnelCosts\n      hostingAndLicences\n      otherCosts\n      depreciation\n      incomeTaxes\n    }\n    recordedBy\n    recordedAt\n    changedBy\n    changedAt\n    balances {\n      bankAccountIdentifier\n      bankAccountName\n      closingBalance\n      computedBalance\n      difference\n    }\n  }\n  bankAccounts {\n    id\n    bankAccountIdentifier\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "998fdaf76412ef284fdaa86b38c8c5ab";

export default node;
